export const SHIPPING = "Shipping";
export const COLLECTIONS = "Collections";
export const DELIVERIES = "Deliveries";
export const SHOP_RETURNS = "Shop Returns";
export const ADDRESS_BOOK = "Address Book";
export const DEPOT_FINDER = "Depot Finder";
export const MY_DPD = "MyDPD";
export const MY_DPD_LOCAL = "MyDPD Local";
export const HELP = "Help";
export const LOGOUT = "Logout";
export const HELP_AND_TIPS = "Help & Tips";
export const HOME = "Home";
export const NO_DATE_SELECTED = "No date selected";
export const STEP$OF$ = (stepNumber, totalSteps) =>
  `Step ${stepNumber} of ${totalSteps}`;
export const GO_TO_LOGIN_PAGE = "Go to Login Page";
export const REPORT_FEEDBACK = "Report Feedback";
export const SHOWING = "Showing";
